import React, { useContext, useState } from 'react'
import {GoogleMap, withScriptjs, withGoogleMap, Marker, InfoWindow} from "react-google-maps";
import { VenueContext } from "../Context"
import {Images }from "./images"
import { VenueContainer } from './Venue';
import { Link } from "react-router-dom"

function Map() {
  let price = Math.floor(Math.random() * 400);
  let rating = Math.floor(Math.random() * 100);
  let capacity = Math.ceil(Math.random() * 900);
  const { venues, dma} = useContext(VenueContext);
  const [selectedVenue, setSelectedVenue] = useState(null)
  console.log(dma)
  let mapCenter = dma === 324 ? { lat: 34.052235, lng: -118.243683} : { lat: 38.005001, lng: -121.805832 };
    return (
        <GoogleMap
            defaultZoom = {9}
            defaultCenter={mapCenter}
        >
        {venues.map(venue => (
          <Marker
            key={venue.id}
            position={venue.location ? {
              lat: parseFloat(venue.location.latitude),
              lng: parseFloat(venue.location.longitude)
            } 
            : {
              lat:34.052235, 
              lng: -118.243683}
            }
            onClick={
              ()=>{
                setSelectedVenue(venue)
              }
            }
          />
         ))}
        {selectedVenue && (
          <InfoWindow
            position={selectedVenue.location ? {
              lat: parseFloat(selectedVenue.location.latitude),
              lng: parseFloat(selectedVenue.location.longitude)
            }
              : {
                lat: 34.052235,
                lng: -118.243683
              }
            }
          onCloseClick={()=>{
            setSelectedVenue(null)
          }}
          >
          <Link to={`/venues/${selectedVenue.name}`}>
            <VenueContainer className="map-card card">
                <img src={Images[Math.floor(Math.random() * 50)]} alt="venue" className="map-image card-img-top"/>
                <div className="card-footer">
                  <p className="name mb-0">{selectedVenue.name}</p>
                  <div>
                    <span className="capacity-title">Capacity:  </span>
                    <span className="capacity">{capacity}   </span>
                    <i class="fas fa-users mr-4"></i>
                    <span className="capacity-title">Rating:  </span>
                    <i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i><i class="fas fa-star"></i>
                    <span className="rating">      {rating}</span>
                    <div>
                      <span className="price-tag">${price}.00</span>
                      <span className="price-label">   Per Hour</span>
                    </div>
                  </div>
                </div>
              </VenueContainer>
            </Link>
          </InfoWindow>
        )}
        </GoogleMap>
    )
}
const WrappedMap = withScriptjs(withGoogleMap(Map))
export default function MapContainer(){
  const MAP_ID = process.env.REACT_APP_MAP_ID
    return <div style={{height:"110vh", padding: " 1rem 0  0 1rem"}}>
      <WrappedMap
        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${MAP_ID}`}
        loadingElement={ <div style={{ height: "100%" }} />}
        containerElement={<div style={{ height: "100%" }} />}
        mapElement={<div style={{ height: "100%" }} />}
        />
    </div>
}
